import { useNetSuiteJournalEntryFieldSettings } from 'shared/hooks';

import { GroupEditItemsField } from '../../hooks';
import { isFieldEditable } from '../../NetSuiteRequestForm/NetSuiteRequestForm.helpers';

export const getGroupEditItemsAvailableFields = (
    fieldSettings: ReturnType<typeof useNetSuiteJournalEntryFieldSettings>
) => {
    const availableFields = [GroupEditItemsField.Account];

    if (isFieldEditable(fieldSettings.itemsTaxCode)) {
        availableFields.push(GroupEditItemsField.TaxCode);
    }

    if (isFieldEditable(fieldSettings.itemsClass)) {
        availableFields.push(GroupEditItemsField.Class);
    }

    if (isFieldEditable(fieldSettings.itemsDepartment)) {
        availableFields.push(GroupEditItemsField.Department);
    }

    if (isFieldEditable(fieldSettings.itemsLocation)) {
        availableFields.push(GroupEditItemsField.Location);
    }

    if (isFieldEditable(fieldSettings.itemsTaxAccount)) {
        availableFields.push(GroupEditItemsField.TaxAccount);
    }

    if (isFieldEditable(fieldSettings.itemsAmortizationSchedule)) {
        availableFields.push(GroupEditItemsField.AmortizationSchedule);
    }

    return availableFields;
};
